// extracted by mini-css-extract-plugin
module.exports = {"section":"ProblemStatement_section__xb4Zg","title":"ProblemStatement_title__6KFiA","subtitle":"ProblemStatement_subtitle__LbLi0"};